export default __webpack_public_path__ + "static/media/whyparticipate-boy.e9a120c0.svg";